import {
  FsyMonthsSchema,
  type FsyAnalysisSection,
  type FsyAnalysisTalk,
  type FsyMonth,
  type FsyRelatedTalkPassage,
} from './schema';

// FSY is intentionally an April 2026-only curated feature. Conference-aware
// surfaces must not treat these fixed talk and paragraph links as current data.

const cookRestoration: FsyRelatedTalkPassage = {
  talkId: '2026-04-sun-pm-06-cook',
  title: 'Keys, Covenants, and Easter',
  speaker: 'Elder Quentin L. Cook',
  paragraphId: 'p_rW4PS',
  excerpt:
    'The appearance of the Savior to the Prophet Joseph Smith and Oliver Cowdery and the keys committed by Moses, Elias, and Elijah are central to the Restoration of the gospel of Jesus Christ in the latter days. The role of Elijah in restoring the priesthood keys of the sealing power is crucial in our journey of returning to our Father as a covenant people.',
  href: '/read/2026-04-sun-pm-06-cook/p_rW4PS#p_rW4PS',
  score: 0.536788,
};

const cookOrdinances: FsyRelatedTalkPassage = {
  talkId: '2026-04-sun-pm-06-cook',
  title: 'Keys, Covenants, and Easter',
  speaker: 'Elder Quentin L. Cook',
  paragraphId: 'p_tAKj6',
  excerpt:
    'Because of the Restoration, we understand the important and pivotal role Elijah has played in the salvation of mankind. Elijah committed to Joseph Smith the priesthood keys pertaining to the sealing power to bind sacred ordinances and covenants on earth and in heaven. This includes the vicarious ordinances of salvation and exaltation that must be performed here on earth in the temples of the Lord. The sealing ordinances are effective after this life and in the eternities\u2014to seal husbands and wives, parents and children. Without these keys, there are no eternal families, and “the whole earth would be utterly wasted.”',
  href: '/read/2026-04-sun-pm-06-cook/p_tAKj6#p_tAKj6',
  score: 0.508614,
};

const cookPromise: FsyRelatedTalkPassage = {
  talkId: '2026-04-sun-pm-06-cook',
  title: 'Keys, Covenants, and Easter',
  speaker: 'Elder Quentin L. Cook',
  paragraphId: 'p_nAEQ1',
  excerpt:
    'I promise to you on this Easter Day that as you adhere to His ordinances, covenants, and commandments, you will grow closer in your relationship with our Savior as well as your appreciation and gratitude for the sealing keys that have been restored in this dispensation.',
  href: '/read/2026-04-sun-pm-06-cook/p_nAEQ1#p_nAEQ1',
  score: 0.482388,
};

const cookKeys: FsyRelatedTalkPassage = {
  talkId: '2026-04-sun-pm-06-cook',
  title: 'Keys, Covenants, and Easter',
  speaker: 'Elder Quentin L. Cook',
  paragraphId: 'p_l44Bm',
  excerpt:
    'The keys committed by ancient prophets to the Prophet Joseph Smith in the Kirtland Temple are an essential part of the restored gospel.',
  href: '/read/2026-04-sun-pm-06-cook/p_l44Bm#p_l44Bm',
  score: 0.578174,
};

const yeeAuthority: FsyRelatedTalkPassage = {
  talkId: '2026-04-sat-am-03-yee',
  title: 'Ministering\u2014“That Ye Love One Another; as I Have Loved You”',
  speaker: 'Sister Kristin M. Yee',
  paragraphId: 'p_usaoL',
  excerpt:
    'As we minister in faith, we do not go alone. The Lord will be with us. He will “provide [the] means whereby [we] can accomplish the thing which he has commanded” \u2014including the blessing of God’s priesthood power as we keep our covenants and His priesthood authority to represent Him through our assignment. The Lord knows the hearts of those we minister to. He loves them and He loves you. He will help you to bless them in the ways they need.',
  href: '/read/2026-04-sat-am-03-yee/p_usaoL#p_usaoL',
  score: 0.483385,
};

const fastSundayTalks: FsyRelatedTalkPassage[] = [
  {
    talkId: '2026-04-sun-am-04-rowe',
    title: 'Choose Jesus Christ as Your Guide',
    speaker: 'Elder Edward B. Rowe',
    paragraphId: 'p_uSF13',
    excerpt:
      'We follow in His footsteps within the covenant path by being in holy places, like the temple, and by having sacred experiences through partaking of the sacrament, praying, studying the scriptures, and ministering to others. The more time we spend with our guide in this way\u2014and strive to follow His example\u2014the more we will develop a deep bond and special relationship with Him and our Heavenly Father.',
    href: '/read/2026-04-sun-am-04-rowe/p_uSF13#p_uSF13',
    score: 0.621457,
  },
  {
    talkId: '2026-04-sun-am-01-uchtdorf',
    title: 'Encounter at the Empty Tomb',
    speaker: 'President Dieter F. Uchtdorf',
    paragraphId: 'p_lsPif',
    excerpt:
      'Those words will change us. They will inspire us to take upon ourselves the name of Christ. And from that moment on, the Light of Christ will begin to bloom within us. It will, in time, bring about a mighty change in our hearts and bless us with a disposition to do good continually. Jesus Christ and His restored gospel are our strength. Jesus Christ is our guide for making choices and will bring joy and happiness in this life and extend into the eternities.',
    href: '/read/2026-04-sun-am-01-uchtdorf/p_lsPif#p_lsPif',
    score: 0.585938,
  },
  {
    talkId: '2026-04-sun-am-02-freeman',
    title: 'Best Days and Worst Days',
    speaker: 'President Emily Belle Freeman',
    paragraphId: 'p_ypN4s',
    excerpt:
      '“ Temple ordinances and covenants give you greater access to God’s blessings,” help you navigate your life with divine guidance, increase your companionship with the Spirit and with angels, and enable you to live up to your privileges and draw upon the power of God.',
    href: '/read/2026-04-sun-am-02-freeman/p_ypN4s#p_ypN4s',
    score: 0.567899,
  },
  {
    talkId: '2026-04-sat-pm-01-stevenson',
    title: 'Lost Luggage, Redeemed Souls',
    speaker: 'Elder Gary E. Stevenson',
    paragraphId: 'p_nBPJ3',
    excerpt:
      'Teach the rising generation to know, love, and emulate their Savior, Jesus Christ. “He is the strength of youth.”',
    href: '/read/2026-04-sat-pm-01-stevenson/p_nBPJ3#p_nBPJ3',
    score: 0.558581,
  },
];

const restorationTalks: FsyRelatedTalkPassage[] = [
  { ...cookRestoration, score: 0.524713 },
  {
    talkId: '2026-04-sun-pm-06-cook',
    title: 'Keys, Covenants, and Easter',
    speaker: 'Elder Quentin L. Cook',
    paragraphId: 'p_ePeRu',
    excerpt:
      'It is noteworthy to me that Elijah also appeared, with Moses, at the time of the transfiguration of Christ. Elijah conferred priesthood keys of the sealing power upon Peter, James, and John.',
    href: '/read/2026-04-sun-pm-06-cook/p_ePeRu#p_ePeRu',
    score: 0.500213,
  },
  {
    talkId: '2026-04-sat-am-05-bednar',
    title: 'All Who Have Endured Valiantly',
    speaker: 'Elder David A. Bednar',
    paragraphId: 'p_eJuzN',
    excerpt:
      'Spiritual gifts are blessings and capacities given by God to His children through the power of the Holy Ghost. All individuals who receive the gift of the Holy Ghost by proper priesthood authority and the laying on of hands are eligible to receive spiritual gifts intended “to bless and benefit those who love the Lord and seek to keep His commandments.” Spiritual gifts are prerequisites for and essential to our coming unto the Savior, being blessed with His attributes, and ultimately becoming more like Him.',
    href: '/read/2026-04-sat-am-05-bednar/p_eJuzN#p_eJuzN',
    score: 0.467242,
  },
  {
    talkId: '2026-04-sun-am-03-larreal',
    title: 'I Feel My Savior’s Love',
    speaker: 'Elder Pedro X. Larreal',
    paragraphId: 'p_sM9Sk',
    excerpt:
      'The resurrected Lord emphasized the importance of the sacrament when He visited the Americas and instituted this ordinance among the faithful Nephites and Lamanites. He blessed the emblems of the sacrament. He gave them to His disciples and then the multitude, and at the same time, He commanded them, saying: “And this shall ye always do to those who repent and are baptized in my name; and ye shall do it in remembrance of my blood, which I have shed for you, that ye may witness unto the Father that ye do always remember me. And if ye do always remember me ye shall have my Spirit to be with you.”',
    href: '/read/2026-04-sun-am-03-larreal/p_sM9Sk#p_sM9Sk',
    score: 0.465112,
  },
];

const lastSundayTalks: FsyRelatedTalkPassage[] = [
  {
    talkId: '2026-04-sat-am-03-yee',
    title: 'Ministering\u2014“That Ye Love One Another; as I Have Loved You”',
    speaker: 'Sister Kristin M. Yee',
    paragraphId: 'p_xqmoE',
    excerpt:
      'We are not called to or released from ministering. It is part of fulfilling the covenants we made at baptism and in the temple. We covenanted to take upon us the Savior’s name \u2014becoming as He is as we sacrifice and consecrate our lives to Him. When we minister as He would, we begin to think, feel, and love as He would.',
    href: '/read/2026-04-sat-am-03-yee/p_xqmoE#p_xqmoE',
    score: 0.630572,
  },
  {
    talkId: '2026-04-sun-am-07-mutombo',
    title: 'The Joy of a Covenant Relationship with God',
    speaker: 'Elder Thierry K. Mutombo',
    paragraphId: 'p_nXbDJ',
    excerpt:
      'Teaching about our discipleship and covenant relationship with our Heavenly Father and our Savior Jesus Christ, our prophet, President Dallin H. Oaks, said: “Following Christ is not a casual or occasional practice. It is a continuous commitment and way of life that should guide us at all times and in all places. His teachings and His example define the path for every disciple of Jesus Christ.”',
    href: '/read/2026-04-sun-am-07-mutombo/p_nXbDJ#p_nXbDJ',
    score: 0.606941,
  },
  { ...yeeAuthority, score: 0.601923 },
  {
    talkId: '2026-04-sun-am-08-walker',
    title: 'A Peculiar Treasure',
    speaker: 'Elder Alan R. Walker',
    paragraphId: 'p_kBt4o',
    excerpt:
      'Covenant faithfulness does more than identify us as God’s people\u2014it empowers us to rise above the limitations of this fallen world. President Dallin H. Oaks has taught that obedience to God’s commandments is essential to rise above life’s challenges. Referring to the sacred covenants that bind us to our Heavenly Father and to His Son, Jesus Christ, he declared, “As we honor those covenants by keeping Their commandments and following Their plan of redemption, Their promised blessings enable us to soar to celestial heights.”',
    href: '/read/2026-04-sun-am-08-walker/p_kBt4o#p_kBt4o',
    score: 0.56197,
  },
];

const sourceBase =
  'https://www.churchofjesuschrist.org/study/ftsoy/2026/09/fsy-lessons';

const FSY_SOURCE_MONTHS = [
  {
    id: '2026-09',
    year: 2026,
    month: 9,
    monthLabel: 'September 2026',
    topic: 'You Are Blessed by Priesthood Keys and Authority',
    guideReference:
      'For the Strength of Youth: A Guide for Making Choices, 46–49',
    attribution: {
      text: 'For the Strength of Youth, September 2026, The Church of Jesus Christ of Latter-day Saints',
      sourceUrl:
        'https://www.churchofjesuschrist.org/study/ftsoy/2026/09?lang=eng',
    },
    items: [
      {
        id: 'month-intro',
        slug: '00-intro',
        type: 'intro',
        title: 'You Are Blessed by Priesthood Keys and Authority',
        blocks: [
          { type: 'paragraph', text: 'September' },
          { type: 'paragraph', text: 'Matthew 16:18–19' },
          {
            type: 'paragraph',
            text: 'Have you ever thought about what your life would be like if God’s priesthood authority had never been restored?',
          },
          {
            type: 'paragraph',
            text: 'If someone asked you what priesthood keys are, how would you answer them?',
          },
          {
            type: 'bullets',
            items: [
              '1. Fast Sunday',
              '2. Second Sunday',
              '3. Third Sunday',
              '4. Last Sunday: Young Women',
              '4. Last Sunday: Aaronic Priesthood Quorums',
            ],
          },
        ],
        sourceUrl: `${sourceBase}/00-intro?lang=eng`,
        relatedTalks: [
          cookRestoration,
          cookOrdinances,
          yeeAuthority,
          cookPromise,
        ],
      },
      {
        id: 'fast-sunday',
        slug: '01-fast-sunday',
        type: 'fast-sunday',
        week: 1,
        scheduleLabel: 'Fast Sunday',
        title: '1. Study the chapter from the FSY guide',
        blocks: [
          {
            type: 'paragraph',
            text: 'In September, the topic of discussion in our Young Women classes and Aaronic Priesthood quorums will be “You are blessed by priesthood keys and authority” (For the Strength of Youth: A Guide for Making Choices, 46–49).',
          },
          {
            type: 'paragraph',
            text: 'Here are some ideas that can guide your discussion:',
          },
          {
            type: 'bullets',
            items: [
              'Choose an eternal truth to discuss. Share thoughts or questions you have about this truth.',
              'Read a scripture together that supports this truth (you can find some verses at the end of the chapter). What message does God have for you in this scripture?',
              'Share a personal story about this truth\u2014maybe an experience you’ve had trying to live it. You could read one of the promised blessings listed in the FSY guide and talk about how the Lord keeps His promises.',
              'Testify. Share what you know about this truth from your own experience and what the Spirit has taught you.',
              'Choose another eternal truth, and repeat this pattern for the rest of the chapter.',
              'Choose an invitation, each fast Sunday, that will help you live what you learned. The FSY guide has several invitations to choose from, or you may feel inspired to think of one of your own.',
            ],
          },
        ],
        sourceUrl: `${sourceBase}/01-fast-sunday?lang=eng`,
        relatedTalks: fastSundayTalks,
      },
      {
        id: 'second-sunday',
        slug: '02-second-sunday',
        type: 'second-sunday',
        week: 2,
        scheduleLabel: 'Second Sunday',
        title: '2. Learn more about the restoration of the priesthood',
        blocks: [
          {
            type: 'paragraph',
            text: 'After Jesus’s New Testament Apostles died, the priesthood\u2014the power and authority of God\u2014was lost from the earth. In the early 1800s, God sent heavenly messengers to restore, or bring back, the priesthood. Through the authority of the priesthood and its ordinances, greater access to the power of God is available to all of us once again.',
          },
          {
            type: 'paragraph',
            text: 'Here are some questions and learning activities you could try:',
          },
          {
            type: 'bullets',
            items: [
              'How does the Savior bless us through the Aaronic Priesthood?',
              'Read Doctrine and Covenants 13:1 and 107:20. What rights and authority did John the Baptist restore to the Prophet Joseph Smith and Oliver Cowdery? Write down words that describe blessings God gives through the Aaronic Priesthood.',
              'How does the Savior bless us through the Melchizedek Priesthood?',
              'Peter, James, and John restored the Melchizedek Priesthood to Joseph and Oliver. Read Doctrine and Covenants 107:18–19 and list some of the “spiritual blessings of the Church” you can access through the Melchizedek Priesthood.',
              'Why does God share His priesthood power with His children?',
              'Through priesthood ordinances\u2014like baptism, the sacrament, and temple ordinances\u2014“the power of godliness is manifest” (see Doctrine and Covenants 84:20–21). Talk with each other about how you have seen the power of God in your life because of the ordinances of the priesthood. What would your life be like without these ordinances?',
              'How would your life be different if the priesthood hadn’t been restored?',
            ],
          },
          {
            type: 'resources',
            title: 'Other resources',
            items: [
              'Guide to the Scriptures, “Authority,” “Priesthood”',
              '“Restoration of the Priesthood and Priesthood Keys,” Preach My Gospel: A Guide to Sharing the Gospel of Jesus Christ (2023), 40',
              'Topics and Questions, “Restoration of the Priesthood” (Gospel Library)',
            ],
          },
        ],
        sourceUrl: `${sourceBase}/02-second-sunday?lang=eng`,
        relatedTalks: restorationTalks,
      },
      {
        id: 'third-sunday',
        slug: '03-third-sunday',
        type: 'third-sunday',
        week: 3,
        scheduleLabel: 'Third Sunday',
        title: '3. Learn more about priesthood keys',
        blocks: [
          {
            type: 'paragraph',
            text: 'Priesthood keys unlock God’s greatest blessings for His children. Priesthood keys are the authority God gives to certain leaders in His Church to organize and direct the kingdom of God on the earth. Those who hold priesthood keys direct how the priesthood is used in the Church.',
          },
          {
            type: 'paragraph',
            text: 'Here are some questions and learning activities you could try:',
          },
          {
            type: 'bullets',
            items: [
              'What is delegated priesthood authority?',
              'If you’ve ever been set apart for a calling or received an assignment under the direction of a leader with priesthood keys, you were given delegated priesthood authority. Discuss what it means “to represent God and act in His name.”',
              'What blessings does the Lord unlock for us through priesthood keys?',
              'Talk about what physical keys are used for. Then discuss this description of priesthood keys: “Priesthood authority and priesthood keys start the engine, open the gates of heaven, facilitate heavenly power, and pave the covenant pathway back to our loving Heavenly Father.”',
              'Why can’t you drive your neighbor’s car? What would you need in order to do so? What does this comparison teach you about priesthood keys?',
              'What priesthood keys has the Lord restored to the earth today?',
              'After the death of Christ and His Apostles, priesthood keys were lost from the earth. Fill out the table below to learn how the Lord restored priesthood keys in our day:',
            ],
          },
          {
            type: 'scripture-table',
            columns: [
              'Scriptures',
              'Heavenly messengers who restored priesthood keys',
              'Priesthood keys they restored',
            ],
            scriptures: [
              'Doctrine and Covenants 13:1',
              'Doctrine and Covenants 27:12–13; 107:8, 18–19',
              'Doctrine and Covenants 110:11',
              'Doctrine and Covenants 110:12',
              'Doctrine and Covenants 110:13–16',
            ],
          },
          {
            type: 'resources',
            title: 'Other resources',
            items: [
              'Guide to the Scriptures, “Keys of the Priesthood”',
              '“Restoration of the Priesthood and Priesthood Keys,” Preach My Gospel, 40',
              'Topics and Questions, “Priesthood Keys” (Gospel Library)',
            ],
          },
          {
            type: 'resources',
            title: 'Notes',
            items: [
              'General Handbook: Serving in The Church of Jesus Christ of Latter-day Saints, 3.4, Gospel Library.',
              'Gary E. Stevenson, “Apr. 2016 general conference” (Ensign or Liahona, May 2016, 32).',
            ],
          },
        ],
        sourceUrl: `${sourceBase}/03-third-sunday?lang=eng`,
        relatedTalks: [
          { ...cookRestoration, score: 0.603168 },
          cookKeys,
          { ...cookOrdinances, score: 0.541153 },
          { ...yeeAuthority, score: 0.453083 },
        ],
      },
      {
        id: 'last-sunday-young-women',
        slug: '04a-fourth-sunday',
        type: 'last-sunday-yw',
        week: 4,
        scheduleLabel: 'Last Sunday',
        audienceLabel: 'Young Women',
        seriesLabel: 'Last Sunday: Young Women',
        title: '4. Becoming a covenant daughter of God',
        blocks: [
          { type: 'heading', text: 'Study together' },
          {
            type: 'paragraph',
            text: 'I am a beloved daughter of heavenly parents, with a divine nature and eternal destiny. I lead, teach, and mentor others courageously by drawing on the power and authority of God and listening to the Spirit.',
          },
          {
            type: 'quote',
            text: '“Thou art an elect lady, whom I have called. … Thou shalt be ordained [set apart] … to expound scriptures, and to exhort the church, according as it shall be given thee by my Spirit.”',
          },
          { type: 'paragraph', text: 'Doctrine and Covenants 25:3, 7' },
          {
            type: 'paragraph',
            text: 'What opportunities do you have to lead, teach, mentor, expound the scriptures, and encourage others? How has doing this brought you closer to the Savior?',
          },
          { type: 'heading', text: 'Learn about Emma Smith,' },
          {
            type: 'paragraph',
            text: 'an elect lady | Doctrine and Covenants 25',
          },
          {
            type: 'paragraph',
            text: 'In Doctrine and Covenants 25, what does the Lord reveal to Emma about living as a covenant daughter of God?',
          },
          {
            type: 'paragraph',
            text: 'What did God call Emma to do? What has He called each of us to do?',
          },
          {
            type: 'paragraph',
            text: 'What does it mean to be an “elect lady”? (see Doctrine and Covenants 25:3).',
          },
          {
            type: 'paragraph',
            text: 'How has the Spirit guided you in doing the work God has given you? (see Doctrine and Covenants 25:7).',
          },
          { type: 'heading', text: 'Live as a disciple of Christ' },
          {
            type: 'paragraph',
            text: 'As you studied the FSY guide this month, what have you learned about the Savior and His priesthood keys and authority?',
          },
          {
            type: 'paragraph',
            text: 'How does this help you accomplish His work?',
          },
        ],
        sourceUrl: `${sourceBase}/04a-fourth-sunday?lang=eng`,
        relatedTalks: lastSundayTalks,
      },
      {
        id: 'last-sunday-aaronic-priesthood',
        slug: '04b-fourth-sunday',
        type: 'last-sunday-ap',
        week: 4,
        scheduleLabel: 'Last Sunday',
        audienceLabel: 'Aaronic Priesthood Quorums',
        seriesLabel: 'Last Sunday: Aaronic Priesthood Quorums',
        title: '4. Becoming a covenant son of God',
        blocks: [
          { type: 'heading', text: 'Study together' },
          {
            type: 'paragraph',
            text: 'I am a beloved son of God, and He has a work for me to do. I will help others connect with God and Jesus Christ by worthily administering in the ordinances of the Aaronic Priesthood, including baptism and the sacrament.',
          },
          {
            type: 'quote',
            text: '“The priest’s duty is to preach, teach, expound, exhort, and baptize, and administer the sacrament.” Teachers and deacons “are … to warn, expound, exhort, and teach, and invite all to come unto Christ.”',
          },
          { type: 'paragraph', text: 'Doctrine and Covenants 20:46, 59' },
          {
            type: 'paragraph',
            text: 'Share an experience when using the priesthood to serve others helped connect you with the Savior.',
          },
          { type: 'heading', text: 'Learn about Joseph Smith,' },
          {
            type: 'paragraph',
            text: 'Prophet of the Restoration | Joseph Smith\u2014History 1:66–73',
          },
          {
            type: 'paragraph',
            text: 'What does Joseph Smith teach us about living as a covenant son of God?',
          },
          {
            type: 'paragraph',
            text: 'How do you think Joseph Smith might have felt to hear John the Baptist call him a fellow servant? Fellow servants serve side by side, under the same master. What does it mean to you to be “fellow servants” with John the Baptist? (verse 69; see also Luke 3:2–6; Doctrine and Covenants 84:26–28).',
          },
          {
            type: 'paragraph',
            text: 'What are some of the “great and glorious blessings” that God has given us through the priesthood? (verse 73). How can we help other people experience these blessings?',
          },
          { type: 'heading', text: 'Live as a disciple of Christ' },
          {
            type: 'paragraph',
            text: 'As you studied the FSY guide this month, what have you learned about the Savior and His priesthood keys and authority?',
          },
          {
            type: 'paragraph',
            text: 'How does this help you accomplish His work?',
          },
        ],
        sourceUrl: `${sourceBase}/04b-fourth-sunday?lang=eng`,
        relatedTalks: lastSundayTalks,
      },
      {
        id: 'one-match-fire-challenge',
        slug: '05a-activity-idea',
        type: 'activity-idea',
        seriesLabel: 'Youth Activity Idea',
        title: 'The One-Match Fire Challenge',
        blocks: [
          {
            type: 'paragraph',
            text: 'Can you build a fire, using a single match, that’s hot enough to burn a string 18 inches above the ground?',
          },
          { type: 'heading', text: 'Purpose' },
          {
            type: 'paragraph',
            text: 'To understand how we can access God’s power in our lives.',
          },
          {
            type: 'resources',
            title: 'Materials Needed',
            items: [
              'Matches',
              'Tinder or kindling',
              'String or twine',
              'Buckets of water or fire extinguishers',
              'Fire-safe surface (gravel, sand, fire rings, or cleared ground)',
            ],
          },
          {
            type: 'resources',
            title: 'Location',
            items: [
              'Outdoors, in a fire-safe area (follow local laws)',
              'Make sure that there are no low-hanging tree branches',
              'Avoid windy or drought conditions',
            ],
          },
          {
            type: 'resources',
            title: 'Safety',
            items: [
              'Adult leaders ensure that youth are safe and instruct them on fire safety',
              'Make sure that fire suppression tools are always on hand',
              'Keep the fire 15 feet away from dry grass and other combustible material',
              'No gasoline, lighter fluid, or other accelerants',
              'Thoroughly extinguish the fire, and never leave the fire or hot coals unattended',
            ],
          },
          { type: 'heading', text: 'The Challenge' },
          {
            type: 'bullets',
            items: [
              'Explain that fire requires heat, oxygen, and fuel.',
              'Youth gather and prepare materials before lighting the match.',
              'Each youth (or pair) is given one match per attempt.',
              'The goal is to build a fire strong enough to burn through a string that is held or suspended 18 inches above the ground.',
              'If the fire goes out, youth must discard materials that touched the flame and begin again, as time allows.',
            ],
          },
          { type: 'heading', text: 'Let’s Talk About It' },
          {
            type: 'paragraph',
            text: 'How is a fire like God’s power in our lives?',
          },
          {
            type: 'paragraph',
            text: 'How are the elements of building a fire like the elements needed to access God’s power in our lives? For example, how could a match be like priesthood authority? How could the wood or kindling be like priesthood ordinances, such as baptism or the sacrament?',
          },
          { type: 'heading', text: 'You Might Point Out' },
          {
            type: 'paragraph',
            text: 'A match has power\u2014but only if it’s used the right way. Similarly, priesthood authority, used as God directs, can help unlock God’s power, providing warmth and light. For example, God directs that His authority be used to make ordinances of salvation available to His children, and “in the ordinances … the power of godliness is manifest” (Doctrine and Covenants 84:20) Priesthood authority, sacred ordinances, and keeping covenants combine to bring the warmth and light of God’s power into our lives.',
          },
        ],
        sourceUrl: `${sourceBase}/05a-activity-idea?lang=eng`,
        relatedTalks: [],
      },
      {
        id: 'flashlight-priesthood-power',
        slug: '05b-activity-idea',
        type: 'activity-idea',
        seriesLabel: 'Youth Activity Idea',
        title: 'A Flashlight and God’s Priesthood Power',
        blocks: [
          {
            type: 'paragraph',
            text: 'See how receiving priesthood ordinances brings light into your life.',
          },
          { type: 'heading', text: 'Purpose' },
          {
            type: 'paragraph',
            text: 'To provide the youth with a navigational experience that helps them learn how the power of the Savior’s priesthood operates in our lives.',
          },
          { type: 'heading', text: 'The Challenge' },
          {
            type: 'bullets',
            items: [
              'Create a navigation experience using a compass, map, Global Positioning System (GPS), or a scavenger hunt. (This can also be an opportunity to teach the youth about how compasses, maps, and GPS function.) Divide the youth into small, mixed-gender groups. Provide each group with a starting location and directions to the first of four stations.',
              'At each station, each group will find one part of a flashlight\u2014batteries, bulb, lens, or body\u2014and a clue to their next station.',
              'After all the parts have been collected, bring the groups together and have them assemble their flashlights. Turn them on and invite everyone to observe the light they produce.',
            ],
          },
          { type: 'heading', text: 'Let’s Talk About It' },
          {
            type: 'paragraph',
            text: 'Why didn’t any single component produce light by itself?',
          },
          {
            type: 'paragraph',
            text: 'What happened when all the parts were assembled correctly?',
          },
          {
            type: 'paragraph',
            text: 'How is the flashlight like priesthood power?',
          },
          {
            type: 'paragraph',
            text: 'Why is it important to remember that all priesthood power comes through Jesus Christ?',
          },
          { type: 'heading', text: 'You Might Point Out' },
          {
            type: 'paragraph',
            text: 'Explain that each flashlight part is important, but none of them produce light on their own. Only when the parts are properly assembled and aligned does the light work. Similarly, priesthood power comes from Jesus Christ. Priesthood keys govern how priesthood authority is used, just as the switch allows the flashlight to function. For example, the ordinances of the priesthood, performed with priesthood authority, can bring light, direction, and protection into our lives as we keep our covenants. Anytime we serve in our callings or assignments in the Church, we exercise delegated priesthood authority, and we help shine the Savior’s light to bless God’s children.',
          },
        ],
        sourceUrl: `${sourceBase}/05b-activity-idea?lang=eng`,
        relatedTalks: [
          { ...cookRestoration, score: 0.587654 },
          { ...cookKeys, score: 0.572512 },
          { ...cookOrdinances, score: 0.562872 },
        ],
      },
    ],
  },
];

type AnalysisTalkSource = Omit<FsyAnalysisTalk, 'relevance'>;

const analysisTalks = {
  cookKeys: {
    talkId: cookKeys.talkId,
    title: cookKeys.title,
    speaker: cookKeys.speaker,
    paragraphId: cookKeys.paragraphId,
    href: `/read/${cookKeys.talkId}/${cookKeys.paragraphId}`,
  },
  cookRestoration: {
    talkId: cookRestoration.talkId,
    title: cookRestoration.title,
    speaker: cookRestoration.speaker,
    paragraphId: cookRestoration.paragraphId,
    href: `/read/${cookRestoration.talkId}/${cookRestoration.paragraphId}`,
  },
  cookOrdinances: {
    talkId: cookOrdinances.talkId,
    title: cookOrdinances.title,
    speaker: cookOrdinances.speaker,
    paragraphId: cookOrdinances.paragraphId,
    href: `/read/${cookOrdinances.talkId}/${cookOrdinances.paragraphId}`,
  },
  cookPromise: {
    talkId: cookPromise.talkId,
    title: cookPromise.title,
    speaker: cookPromise.speaker,
    paragraphId: cookPromise.paragraphId,
    href: `/read/${cookPromise.talkId}/${cookPromise.paragraphId}`,
  },
  yeeAuthority: {
    talkId: yeeAuthority.talkId,
    title: yeeAuthority.title,
    speaker: yeeAuthority.speaker,
    paragraphId: yeeAuthority.paragraphId,
    href: `/read/${yeeAuthority.talkId}/${yeeAuthority.paragraphId}`,
  },
  yeeCovenants: {
    talkId: '2026-04-sat-am-03-yee',
    title: 'Ministering\u2014“That Ye Love One Another; as I Have Loved You”',
    speaker: 'Sister Kristin M. Yee',
    paragraphId: 'p_xqmoE',
    href: '/read/2026-04-sat-am-03-yee/p_xqmoE',
  },
  freemanGuide: {
    talkId: '2026-04-sun-am-02-freeman',
    title: 'Best Days and Worst Days',
    speaker: 'President Emily Belle Freeman',
    paragraphId: 'p_swhjs',
    href: '/read/2026-04-sun-am-02-freeman/p_swhjs',
  },
  freemanOrdinances: {
    talkId: '2026-04-sun-am-02-freeman',
    title: 'Best Days and Worst Days',
    speaker: 'President Emily Belle Freeman',
    paragraphId: 'p_ypN4s',
    href: '/read/2026-04-sun-am-02-freeman/p_ypN4s',
  },
  roweDiscipleship: {
    talkId: '2026-04-sun-am-04-rowe',
    title: 'Choose Jesus Christ as Your Guide',
    speaker: 'Elder Edward B. Rowe',
    paragraphId: 'p_uSF13',
    href: '/read/2026-04-sun-am-04-rowe/p_uSF13',
  },
  larrealSacrament: {
    talkId: '2026-04-sun-am-03-larreal',
    title: 'I Feel My Savior’s Love',
    speaker: 'Elder Pedro X. Larreal',
    paragraphId: 'p_sM9Sk',
    href: '/read/2026-04-sun-am-03-larreal/p_sM9Sk',
  },
  bednarGifts: {
    talkId: '2026-04-sat-am-05-bednar',
    title: 'All Who Have Endured Valiantly',
    speaker: 'Elder David A. Bednar',
    paragraphId: 'p_eJuzN',
    href: '/read/2026-04-sat-am-05-bednar/p_eJuzN',
  },
  kearonService: {
    talkId: '2026-04-sat-am-02-kearon',
    title: 'About His Business',
    speaker: 'Elder Patrick Kearon',
    paragraphId: 'p_zHRwP',
    href: '/read/2026-04-sat-am-02-kearon/p_zHRwP',
  },
  walkerCovenants: {
    talkId: '2026-04-sun-am-08-walker',
    title: 'A Peculiar Treasure',
    speaker: 'Elder Alan R. Walker',
    paragraphId: 'p_kBt4o',
    href: '/read/2026-04-sun-am-08-walker/p_kBt4o',
  },
  soaresChoices: {
    talkId: '2026-04-sat-pm-08-soares',
    title: 'Jesus Christ\u2014the True Vine',
    speaker: 'Elder Ulisses Soares',
    paragraphId: 'p_xzy7x',
    href: '/read/2026-04-sat-pm-08-soares/p_xzy7x',
  },
} satisfies Record<string, AnalysisTalkSource>;

function analyzedTalk(
  source: AnalysisTalkSource,
  relevance: string,
): FsyAnalysisTalk {
  return { ...source, relevance };
}

function section(
  id: string,
  blockIndex: number,
  talks: FsyAnalysisTalk[],
  itemIndex?: number,
): FsyAnalysisSection {
  return { id, blockIndex, ...(itemIndex === undefined ? {} : { itemIndex }), talks };
}

const analysisByItem: Record<string, FsyAnalysisSection[]> = {
  'month-intro': [
    section('authority-restored', 2, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook identifies the restored keys from Moses, Elias, and Elijah as central to the latter-day Restoration. His explanation shows how those keys make a covenant return to Heavenly Father possible.',
      ),
    ]),
    section('what-keys-are', 3, [
      analyzedTalk(
        analysisTalks.cookKeys,
        'Elder Cook names priesthood keys committed by ancient prophets as an essential part of the restored gospel. The paragraph gives a concise conference foundation for defining why priesthood keys matter now.',
      ),
    ]),
  ],
  'fast-sunday': [
    section('monthly-guide-topic', 0, [
      analyzedTalk(
        analysisTalks.freemanGuide,
        'President Freeman describes turning to the For the Strength of Youth guide for eternal truths, invitations, and promised blessings. Her experience directly models using the guide to find strength in Christ during a real need.',
      ),
    ]),
    section('choose-eternal-truth', 2, [
      analyzedTalk(
        analysisTalks.freemanGuide,
        'President Freeman tests the guide’s eternal truths against a difficult day in her own family. Her example supports choosing one truth and exploring how it gives practical strength in Christ.',
      ),
    ], 0),
    section('study-scripture', 2, [
      analyzedTalk(
        analysisTalks.roweDiscipleship,
        'Elder Rowe includes scripture study among the sacred practices that keep disciples in the footsteps of Jesus Christ. He connects repeated time with the Savior to a deeper relationship with Him and Heavenly Father.',
      ),
    ], 1),
    section('promised-blessings', 2, [
      analyzedTalk(
        analysisTalks.walkerCovenants,
        'Elder Walker teaches that honoring covenants activates promised blessings that lift disciples above mortal limitations. His statement gives a concrete conference witness that the Lord keeps covenant promises.',
      ),
    ], 2),
    section('choose-invitation', 2, [
      analyzedTalk(
        analysisTalks.soaresChoices,
        'Elder Soares describes discipleship as a constant choice guided by covenants and the Holy Ghost. His counsel supports turning a lesson invitation into deliberate action beyond the Sunday discussion.',
      ),
    ], 5),
  ],
  'second-sunday': [
    section('restoration-overview', 0, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook places the Savior’s appearance and the return of priesthood keys at the center of the Restoration. He specifically connects restored sealing keys with the covenant journey back to Heavenly Father.',
      ),
    ]),
    section('aaronic-blessings', 2, [
      analyzedTalk(
        analysisTalks.larrealSacrament,
        'Elder Larreal recounts the resurrected Savior instituting the sacrament and promising His Spirit to those who remember Him. That ordinance is a direct example of how Aaronic Priesthood service brings a recurring blessing from Jesus Christ.',
      ),
    ], 0),
    section('john-the-baptist-restoration', 2, [], 1),
    section('melchizedek-blessings', 2, [
      analyzedTalk(
        analysisTalks.bednarGifts,
        'Elder Bednar teaches that the gift of the Holy Ghost is received through proper priesthood authority and opens access to spiritual gifts. His explanation identifies specific spiritual blessings available through restored Melchizedek Priesthood ordinances.',
      ),
    ], 2),
    section('spiritual-blessings-access', 2, [
      analyzedTalk(
        analysisTalks.bednarGifts,
        'Elder Bednar identifies spiritual gifts as blessings received through the Holy Ghost after an ordinance performed by proper priesthood authority. His teaching supplies concrete examples of spiritual access made possible through the Melchizedek Priesthood.',
      ),
    ], 3),
    section('why-god-shares-power', 2, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee explains that God gives priesthood power and delegated authority so disciples can represent Him and bless people according to their needs. Her teaching frames shared divine power as a means of extending the Savior’s personal care.',
      ),
    ], 4),
    section('ordinances-manifest-power', 2, [
      analyzedTalk(
        analysisTalks.freemanOrdinances,
        'President Freeman names temple ordinances and covenants as sources of divine guidance, spiritual companionship, and access to God’s power. Her list makes the effects of priesthood ordinances concrete in daily life.',
      ),
      analyzedTalk(
        analysisTalks.larrealSacrament,
        'Elder Larreal shows the Savior personally instituting an ordinance and attaching the promise of His Spirit to it. The sacrament provides a specific example of godly power becoming available through an authorized ordinance.',
      ),
    ], 5),
    section('life-without-restoration', 2, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook calls restored priesthood keys central to the latter-day Restoration and the covenant journey home. His teaching identifies an eternal direction and sealing power that would be absent without the Restoration.',
      ),
    ], 6),
  ],
  'third-sunday': [
    section('keys-definition', 0, [
      analyzedTalk(
        analysisTalks.cookKeys,
        'Elder Cook calls restored priesthood keys essential to the restored gospel. His focus on keys committed by ancient prophets complements the lesson’s definition of authority to direct God’s work.',
      ),
    ]),
    section('delegated-authority-question', 2, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee describes priesthood authority as authorization to represent the Lord through an inspired assignment. Her example provides a direct conference answer to the lesson’s question about delegated authority.',
      ),
    ], 0),
    section('delegated-authority', 2, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee explicitly connects inspired assignments with priesthood authority to represent the Lord. Her teaching gives a current example of delegated authority operating through Church service.',
      ),
    ], 1),
    section('blessings-unlocked', 2, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook explains that restored sealing keys bind sacred ordinances and covenants on earth and in heaven. Eternal family relationships are the specific blessing he identifies as impossible without those keys.',
      ),
    ], 3),
    section('blessings-unlocked-question', 2, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook identifies eternal family sealing as a blessing unlocked through restored priesthood keys. He explains that those keys make binding ordinances and covenants effective on earth and in heaven.',
      ),
    ], 2),
    section('physical-key-comparison', 2, [], 4),
    section('keys-restored-today', 2, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook identifies Moses, Elias, and Elijah as messengers who committed keys in the latter days. His paragraph directly anchors the lesson’s study of which priesthood keys have been restored.',
      ),
    ], 5),
    section('restoration-table', 3, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook summarizes the Kirtland Temple restoration of keys by named heavenly messengers. The paragraph provides a conference overview to pair with the table’s detailed scripture study.',
      ),
    ]),
  ],
  'last-sunday-young-women': [
    section('covenant-daughter-authority', 1, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee teaches that covenant keepers can receive priesthood power and authority to represent the Savior through assignments. Her statement directly supports young women leading and serving with God’s authority while listening to the Spirit.',
      ),
    ]),
    section('lead-teach-mentor', 4, [
      analyzedTalk(
        analysisTalks.kearonService,
        'Elder Kearon describes every calling as participation in the Savior’s work of lifting, comforting, and sharing good news. His teaching gives purpose to opportunities to lead, teach, mentor, and encourage others.',
      ),
    ]),
    section('elect-lady-covenant', 7, [
      analyzedTalk(
        analysisTalks.walkerCovenants,
        'Elder Walker teaches that covenant faithfulness both identifies God’s people and empowers them. That connection illuminates Emma Smith’s identity and responsibilities as an elect covenant daughter.',
      ),
    ]),
    section('called-to-do', 8, [
      analyzedTalk(
        analysisTalks.kearonService,
        'Elder Kearon frames a calling as joining the Savior in His redeeming work rather than merely filling an assignment. His perspective helps connect Emma’s call with the work God gives each disciple.',
      ),
    ]),
    section('elect-lady-meaning', 9, [
      analyzedTalk(
        analysisTalks.walkerCovenants,
        'Elder Walker says covenant faithfulness identifies disciples as God’s people and empowers them to rise. His teaching connects covenant identity with the divine capacity to fulfill a sacred role.',
      ),
    ]),
    section('spirit-guidance', 10, [
      analyzedTalk(
        analysisTalks.bednarGifts,
        'Elder Bednar identifies spiritual gifts as capacities given through the Holy Ghost to help disciples become like the Savior. His teaching supports recognizing the Spirit’s guidance while carrying out God-given work.',
      ),
    ]),
    section('monthly-keys-learning', 12, [
      analyzedTalk(
        analysisTalks.cookPromise,
        'Elder Cook promises that honoring ordinances, covenants, and commandments deepens a disciple’s relationship with the Savior. He also connects that growth with gratitude for restored sealing keys.',
      ),
    ]),
    section('accomplish-his-work', 13, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee promises that the Lord accompanies those who minister in faith and helps them bless people according to their needs. Her teaching shows how priesthood power and delegated authority enable disciples to accomplish His work.',
      ),
    ]),
  ],
  'last-sunday-aaronic-priesthood': [
    section('aaronic-ordinances', 1, [
      analyzedTalk(
        analysisTalks.larrealSacrament,
        'Elder Larreal recounts Jesus Christ instituting the sacrament and giving it to His disciples and the multitude. The account centers the Aaronic Priesthood ordinance on helping people remember the Savior and receive His Spirit.',
      ),
    ]),
    section('priesthood-service', 4, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee teaches that representing the Lord through an assignment brings His help to both the servant and the person being served. Her statement clarifies why using priesthood authority to serve can strengthen a connection with the Savior.',
      ),
    ]),
    section('joseph-restoration', 7, [
      analyzedTalk(
        analysisTalks.cookRestoration,
        'Elder Cook identifies Joseph Smith and Oliver Cowdery as recipients of restored keys from heavenly messengers. His account places their service within the larger Restoration of covenant authority.',
      ),
    ]),
    section('fellow-servants', 8, [
      analyzedTalk(
        analysisTalks.kearonService,
        'Elder Kearon describes Church service as joining the Savior in His work rather than simply completing an assignment. That shared labor gives practical meaning to being fellow servants under one Master.',
      ),
    ]),
    section('priesthood-blessings', 9, [
      analyzedTalk(
        analysisTalks.freemanOrdinances,
        'President Freeman identifies divine guidance, companionship with the Spirit and angels, and access to God’s power as blessings of ordinances and covenants. Her list supplies specific examples of the great blessings youth can help others receive.',
      ),
    ]),
    section('ap-monthly-learning', 11, [
      analyzedTalk(
        analysisTalks.cookPromise,
        'Elder Cook ties restored sealing keys to ordinances, covenants, and a closer relationship with the Savior. His promise summarizes why learning about priesthood keys should lead to covenant discipleship.',
      ),
    ]),
    section('ap-accomplish-work', 12, [
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee explains that the Lord provides priesthood power and authority as disciples represent Him through assignments. She also promises His personal help in blessing people according to their needs.',
      ),
    ]),
  ],
  'one-match-fire-challenge': [
    section('one-match-challenge', 0, []),
    section('access-gods-power', 2, [
      analyzedTalk(
        analysisTalks.freemanOrdinances,
        'President Freeman teaches that ordinances and covenants increase access to God’s blessings and power. Her explanation gives doctrinal substance to the activity’s purpose of learning how divine power is accessed.',
      ),
    ]),
    section('fire-and-power', 9, [
      analyzedTalk(
        analysisTalks.larrealSacrament,
        'Elder Larreal describes the sacrament as an ordinance instituted by Jesus Christ with a promised spiritual result. That pattern supports the activity’s comparison between authorized ordinances and conditions that make power available.',
      ),
    ]),
    section('fire-elements-and-ordinances', 10, [
      analyzedTalk(
        analysisTalks.larrealSacrament,
        'Elder Larreal shows the Savior joining an authorized ordinance with covenant remembrance and a promised gift of the Spirit. His example gives the activity a specific doctrinal pattern for how authority, ordinances, and faithful participation combine.',
      ),
    ]),
    section('authority-ordinances-covenants', 12, [
      analyzedTalk(
        analysisTalks.freemanOrdinances,
        'President Freeman connects temple ordinances and covenants with divine guidance, the Spirit, angels, and God’s power. Her teaching parallels the lesson’s conclusion that authority, ordinances, and covenant keeping work together.',
      ),
    ]),
  ],
  'flashlight-priesthood-power': [
    section('navigational-purpose', 2, [
      analyzedTalk(
        analysisTalks.roweDiscipleship,
        'Elder Rowe portrays Jesus Christ as a personal guide whose covenant path includes ordinances, prayer, scripture study, and service. His imagery directly complements a navigation activity about how priesthood power operates.',
      ),
    ]),
    section('parts-produce-light', 7, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook shows priesthood keys, ordinances, and covenants functioning together to bind families on earth and in heaven. His example supports the flashlight comparison in which aligned parts produce an effect no single component can create.',
      ),
    ]),
    section('single-component', 6, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook describes keys, ordinances, and covenants working together to create an eternal sealing effect. His example supports the insight that no isolated component represents the full operation of priesthood power.',
      ),
    ]),
    section('flashlight-and-power', 8, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook connects priesthood keys with ordinances and covenants that bind families across earth and heaven. That coordinated use of authority parallels the flashlight’s need for correctly assembled parts before light appears.',
      ),
    ]),
    section('power-through-christ', 9, [
      analyzedTalk(
        analysisTalks.roweDiscipleship,
        'Elder Rowe places Jesus Christ at the center of the covenant path and every sacred practice along it. His teaching reinforces that priesthood power is not independent of Christ but flows through a relationship with Him.',
      ),
    ]),
    section('light-direction-protection', 11, [
      analyzedTalk(
        analysisTalks.cookOrdinances,
        'Elder Cook demonstrates that keys govern ordinances whose covenant effects reach into eternity. His sealing example grounds the activity’s claim that keys, authority, ordinances, and covenants must operate in alignment.',
      ),
      analyzedTalk(
        analysisTalks.yeeAuthority,
        'Sister Yee explains that Church assignments carry priesthood authority to represent the Savior and bless His children. Her teaching directly supports the activity’s statement that youth exercise delegated authority in callings and assignments.',
      ),
    ]),
  ],
};

export const FSY_MONTHS: FsyMonth[] = FsyMonthsSchema.parse(
  FSY_SOURCE_MONTHS.map((month) => ({
    ...month,
    items: month.items.map((item) => ({
      ...item,
      analysisSections: analysisByItem[item.id] ?? [],
    })),
  })),
);

export function findFsyMonth(monthId: string): FsyMonth | undefined {
  return FSY_MONTHS.find((month) => month.id === monthId);
}
